export const introductionContent = {
  ja: {
    name: "@abap34",
    mainDescription: "機械学習とプログラミング言語が好きです. 理論も実装もできる研究者・エンジニアが目標です.",
    detailedDescription: [
      "最近はプログラミング言語の知識を機械学習に生かすこと，もしくは機械学習の知識をプログラミング言語に生かすことを考えています．",
      "",
      "そのほか 数理最適化 (とくに連続最適化), 数理統計に関連する領域に関心があります.",
      "必要に応じて Web 開発 (React, FastAPI を使うことが多いです) もします．",
      "よく使うプログラミング言語は Python, Julia, TypeScript, C++, Scheme などです．",
      "",
      "普段はプログラムを書くか音楽を聴くか野球を観て暮らしています．"
    ]
  },
  en: {
    name: "@abap34",
    mainDescription: "Machine Learning & Programming Languages enthusiast. I aim to be a researcher/engineer who can do both theory and implementation.",
    detailedDescription: [
      "Recently, I have been thinking about how to leverage programming language knowledge in machine learning, or vice versa.",
      "",
      "Other interests include mathematical optimization (especially continuous optimization) and mathematical statistics, as well as related fields.",
      "I also do web development (often using React and FastAPI) when necessary.",
      "I often use programming languages such as Python, Julia, TypeScript, C++, and Scheme.",
      "",
      "I usually spend my time writing programs, listening to music, or watching baseball."
    ]
  }
};

export const socialLinks = [
  {
    name: "GitHub",
    url: "https://github.com/abap34",
    icon: "FaGithub",
    hoverColor: "hover:text-black dark:hover:text-white"
  },
  {
    name: "Twitter", 
    url: "https://twitter.com/abap34",
    icon: "FaTwitter",
    hoverColor: "hover:text-blue-400 dark:hover:text-blue-300"
  },
  {
    name: "SpeakerDeck",
    url: "https://speakerdeck.com/abap34", 
    icon: "FaSpeakerDeck",
    hoverColor: "hover:text-green-500 dark:hover:text-green-400"
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/yuchi-yamaguchi-981a83332",
    icon: "FaLinkedin", 
    hoverColor: "hover:text-blue-700 dark:hover:text-blue-500"
  }
];

export const aboutContent = {
  ja: {
    sections: {
      recentPosts: "Recent Blog Posts",
      contact: "Contact"
    },
    messages: {
      viewAllPosts: "すべての投稿を見る",
      loadingPosts: "投稿を読み込んでいます...",
      contactText: "abap0002 [at] gmail.com or Send me a message on"
    }
  },
  en: {
    sections: {
      recentPosts: "Recent Blog Posts", 
      contact: "Contact"
    },
    messages: {
      viewAllPosts: "View all publications",
      loadingPosts: "Loading publications...",
      contactText: "abap0002 [at] gmail.com or Send me a message on"
    }
  }
};